import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IRezervasyonListe_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IRezervasyonListe_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  TalepEdenListe: any[];
  TalepEdenListe_dummy: any[];
  MurettebatComboListe: any[];
  MurettebatComboListe_dummy: any[];
  YolcuKomboListe: any[];
  YolcuKomboListe_dummy: any[];
  DatePart: Date;
  DatePart_dummy: Date;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetYetki: any;
  GetYetki_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  Notify: boolean;
  Notify_dummy: boolean;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  RezervasyonSearch: any[];
  RezervasyonSearch_dummy: any[];
  isComp385716Visible: "visible" | "hidden";
  isComp321240Visible: "visible" | "hidden";
  isComp176359Visible: "visible" | "hidden";
  isComp822186Visible: "visible" | "hidden";
  isComp740399Enabled: "enabled" | "disabled";
  isComp758026Enabled: "enabled" | "disabled";
  isComprezervasyonliste_321240AuthorizationVisible: "visible" | "hidden";
  isComprezervasyonliste_176359AuthorizationVisible: "visible" | "hidden";
  isComprezervasyonliste_740399AuthorizationEnabled: "enabled" | "disabled";
  isComprezervasyonliste_758026AuthorizationEnabled: "enabled" | "disabled";
  isComprezervasyonliste_255630AuthorizationEnabled: "enabled" | "disabled";
}

export class RezervasyonListe_ScreenBase extends React.PureComponent<
  IRezervasyonListe_ScreenProps,
  any
> {
  rezervasyonliste_740399_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonliste_758026_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonliste_255630_value_kuikaSelectBoxRef: React.RefObject<any>;
  rezervasyonliste_399769_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "15bc17e0-de7f-4128-ae51-48d3d840fff8",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 923160, PropertyName: "value", Value: "Rezervasyon Listesi" },
        { Id: 385716, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 410220, PropertyName: "label", Value: "Taslak" },
        { Id: 20557, PropertyName: "label", Value: "Kayitli" },
        { Id: 240898, PropertyName: "label", Value: "Onaylı" },
        { Id: 13370, PropertyName: "label", Value: "Red" },
        { Id: 530589, PropertyName: "label", Value: "İptal" },
        { Id: 590122, PropertyName: "label", Value: "Uçuldu" },
        { Id: 485963, PropertyName: "label", Value: "Silindi" },
        { Id: 848050, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 191557,
          PropertyName: "startDatePlaceholder",
          Value: "Başlangıç",
        },
        { Id: 191557, PropertyName: "endDatePlaceholder", Value: "Bitiş" },
        { Id: 887234, PropertyName: "value", Value: "Talep Eden" },
        { Id: 740399, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 727455, PropertyName: "value", Value: "Yolcu" },
        { Id: 758026, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 123526, PropertyName: "value", Value: "Mürettebat" },
        { Id: 255630, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 135352, PropertyName: "label", Value: "Listele" },
        {
          Id: 399769,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 6872087, PropertyName: "title", Value: "Rezervasyon No" },
        {
          Id: 6476116,
          PropertyName: "value",
          Value: "[datafield:rezervasyonno]",
        },
        { Id: 7559311, PropertyName: "title", Value: "Kalkış Saat" },
        { Id: 3046555, PropertyName: "value", Value: "[datafield:kalkissaat]" },
        { Id: 9350491, PropertyName: "title", Value: "Kalkış Nokta" },
        {
          Id: 7317383,
          PropertyName: "value",
          Value: "[datafield:kalkisnoktaaciklama]",
        },
        { Id: 6388779, PropertyName: "title", Value: "Varış Saat" },
        { Id: 3099204, PropertyName: "value", Value: "[datafield:varissaat]" },
        { Id: 5492710, PropertyName: "title", Value: "Varış Nokta" },
        {
          Id: 9067523,
          PropertyName: "value",
          Value: "[datafield:varisnoktaaciklama]",
        },
        { Id: 690140, PropertyName: "title", Value: "Durum" },
        { Id: 638417, PropertyName: "value", Value: "[datafield:onaydurumad]" },
        { Id: 91317, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 5566975, PropertyName: "title", Value: "Uçuş Tipi" },
        { Id: 5326431, PropertyName: "value", Value: "[datafield:ucustipiad]" },
        { Id: 352959, PropertyName: "title", Value: "Gidiş Rezervasyon No" },
        {
          Id: 654194,
          PropertyName: "value",
          Value: "[datafield:gidisrezervasyonno]",
        },
        { Id: 923777, PropertyName: "placeholder", Value: "15" },
        { Id: 6694941, PropertyName: "title", Value: "Dönüş Rezervasyon No" },
        {
          Id: 2259155,
          PropertyName: "value",
          Value: "[datafield:donusrezervasyonno]",
        },
        { Id: 7286459, PropertyName: "title", Value: "Talep eden" },
        { Id: 3708643, PropertyName: "value", Value: "[datafield:talepeden]" },
        { Id: 2789586, PropertyName: "title", Value: "Yolcular" },
        { Id: 9602969, PropertyName: "value", Value: "[datafield:yolcular]" },
        { Id: 734677, PropertyName: "title", Value: "Yolcu Adet" },
        { Id: 167995, PropertyName: "value", Value: "[datafield:yolcuadet]" },
        { Id: 219036, PropertyName: "placeholder", Value: "15" },
        { Id: 4983520, PropertyName: "title", Value: "Onaylayan" },
        { Id: 1178565, PropertyName: "value", Value: "[datafield:onaylayan]" },
        { Id: 5046063, PropertyName: "title", Value: "Mürettebat" },
        { Id: 5960956, PropertyName: "value", Value: "[datafield:murettebat]" },
        { Id: 3435235, PropertyName: "title", Value: "Kalkış Gün Doğumu" },
        {
          Id: 3355738,
          PropertyName: "value",
          Value: "[datafield:kalkisgundogumu]",
        },
        { Id: 7081019, PropertyName: "title", Value: "Kalkış Gün Batımı" },
        {
          Id: 8110201,
          PropertyName: "value",
          Value: "[datafield:kalkisgunbatimi]",
        },
        { Id: 2497427, PropertyName: "title", Value: "Varış Gün Doğumu" },
        {
          Id: 2988767,
          PropertyName: "value",
          Value: "[datafield:varisgundogumu]",
        },
        { Id: 1550879, PropertyName: "title", Value: "Varış Gün Batımı" },
        {
          Id: 9628058,
          PropertyName: "value",
          Value: "[datafield:varisgunbatimi]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.rezervasyonliste_385716_value_kuikaTextInputRef = React.createRef();
    this.rezervasyonliste_740399_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonliste_758026_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonliste_255630_value_kuikaSelectBoxRef = React.createRef();
    this.rezervasyonliste_399769_value_kuikaTableRef = React.createRef();
    this.rezervasyonliste_91317_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      TalepEdenListe: [],
      MurettebatComboListe: [],
      YolcuKomboListe: [],
      DatePart: "",
      SetValueOf: "",
      GetYetki: "",
      IfThenElse: false,
      TriggerEvent: "",
      RezervasyonSearch: [],
      isComp385716Visible: "hidden",
      isComp321240Visible: "hidden",
      isComp176359Visible: "hidden",
      isComp822186Visible: "hidden",
      isComp740399Enabled: "disabled",
      isComp758026Enabled: "disabled",
      isComprezervasyonliste_321240AuthorizationVisible: "visible",
      isComprezervasyonliste_176359AuthorizationVisible: "visible",
      isComprezervasyonliste_740399AuthorizationEnabled: "enabled",
      isComprezervasyonliste_758026AuthorizationEnabled: "enabled",
      isComprezervasyonliste_255630AuthorizationEnabled: "enabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("rezervasyonliste", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.RezervasyonListePageInit();
    }
    ReactSystemFunctions.disableIsNotAuthorized(
      this,
      "isComprezervasyonliste_740399AuthorizationEnabled",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );
    ReactSystemFunctions.disableIsNotAuthorized(
      this,
      "isComprezervasyonliste_758026AuthorizationEnabled",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );
    ReactSystemFunctions.disableIsNotAuthorized(
      this,
      "isComprezervasyonliste_255630AuthorizationEnabled",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComprezervasyonliste_321240AuthorizationVisible",
      [
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "9f403c50-ba00-7e15-6037-c337868f5fa9",
        "ccb35799-0363-fc05-c37e-ddce637f2df6",
        "FLYYOLCU",
        "FLYPILOT",
        "FLYORTAK",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComprezervasyonliste_176359AuthorizationVisible",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonliste", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYYOLCU",
      "FLYASISTAN",
      "FLYPILOT",
      "FLYTEKNISYEN",
      "FLYMALIISLER",
      "FLYADMIN",
      "FLYORTAK",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("rezervasyonliste", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.RezervasyonListePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      rezervasyonliste_410220_checked: false,
      rezervasyonliste_20557_checked: true,
      rezervasyonliste_240898_checked: true,
      rezervasyonliste_13370_checked: true,
      rezervasyonliste_530589_checked: true,
      rezervasyonliste_590122_checked: true,
      rezervasyonliste_485963_checked: false,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  RezervasyonListePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      date_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonListe/RezervasyonListePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TalepEdenListe = result?.data.talepEdenListe;

    formVars.rezervasyonliste_740399_options = stateVars.TalepEdenListe;
    stateVars.MurettebatComboListe = result?.data.murettebatComboListe;

    formVars.rezervasyonliste_255630_options = stateVars.MurettebatComboListe;
    stateVars.YolcuKomboListe = result?.data.yolcuKomboListe;

    formVars.rezervasyonliste_758026_options = stateVars.YolcuKomboListe;
    stateVars.DatePart = result?.data.datePart;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonListePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonListePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_191557_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.DatePart),
      ReactSystemFunctions.convertToTypeByName("startValue", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_385716_value",
        "string"
      ),
      ReactSystemFunctions.getMyRoleNames(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonListePageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonListePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      yetkiStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_385716_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonListe/RezervasyonListePageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetYetki = result?.data.getYetki;
    stateVars.isComp740399Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, stateVars.GetYetki?.yolcu),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp758026Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.GetYetki?.yolcu),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonListePageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonListePageInit_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_740399_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      "Filtre"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_410220_checked",
        "string"
      ),
      true,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonListePageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.GetYetki?.yolcu),
        true
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.GetYetki?.ortak),
        true
      )
    ) {
      isErrorOccurred = await this.RezervasyonListePageInit_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.RezervasyonListePageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  RezervasyonListePageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        this.props.screenInputs.Murettebat ??
          this.props.screenInputs.murettebat,
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonliste_255630_value",
          "string"
        ),
        this.props.screenInputs.Murettebat ??
          this.props.screenInputs.murettebat,
        null,
        "Filtre"
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.RezervasyonListePageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.RezervasyonListePageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  RezervasyonListePageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        this.props.screenInputs.Yolcu ?? this.props.screenInputs.yolcu,
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "rezervasyonliste_758026_value",
          "string"
        ),
        this.props.screenInputs.Yolcu ?? this.props.screenInputs.yolcu,
        null,
        "Filtre"
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.RezervasyonListePageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.RezervasyonListePageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  RezervasyonListePageInit_if6 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_20557_checked",
        "string"
      ),
      false,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_13370_checked",
        "string"
      ),
      false,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_530589_checked",
        "string"
      ),
      false,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_590122_checked",
        "string"
      ),
      false,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "rezervasyonliste_410220_checked",
        "string"
      ),
      false,
      null,
      false
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "c696e8d5_7b5f_d08e_5ebc_e9d6eddaef5e_notify",
        this.defaultML,
        "Onaylı rezervasyonlardan uçuş kaydı yaratınız..."
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonListePageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.IsUcusYarat ??
          this.props.screenInputs.isucusyarat,
        true
      )
    ) {
      isErrorOccurred = await this.RezervasyonListePageInit_if6();
      if (isErrorOccurred) return true;
    } else {
    }

    if (await this.RezervasyonListeComponent_135352_onClick()) return true;

    stateVars.dataSource_740399 =
      stateVars.TalepEdenListe ?? this.state.TalepEdenListe;
    stateVars.dataSource_740399 =
      stateVars.TalepEdenListe ?? this.state.TalepEdenListe;
    stateVars.isComp740399Enabled =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, this.state.GetYetki?.yolcu),
        true
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_758026 =
      stateVars.YolcuKomboListe ?? this.state.YolcuKomboListe;
    stateVars.dataSource_758026 =
      stateVars.YolcuKomboListe ?? this.state.YolcuKomboListe;
    stateVars.isComp758026Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.GetYetki?.yolcu),
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_255630 =
      stateVars.MurettebatComboListe ?? this.state.MurettebatComboListe;
    stateVars.dataSource_255630 =
      stateVars.MurettebatComboListe ?? this.state.MurettebatComboListe;
    stateVars.isComp321240Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "rezervasyonliste_399769_value",
          "donusRezervasyonNo"
        ),
        true
      ) &&
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_399769_value",
            "gidisRezervasyonNo"
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp176359Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "rezervasyonliste_399769_value",
          "onayDurumu"
        ),
        "2"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  RezervasyonListeComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonListe",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "139195",
      null,
      "left",
      "true",
      "450px",
      "",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_135352_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Taslak_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_410220_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Kayit_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_20557_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Onay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_240898_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Red_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_13370_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Iptal_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_530589_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Silindi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_485963_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Uculdu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_590122_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      BaslangicTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_191557_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_191557_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TalepEden_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_740399_value",
            "value",
            "TalepEdenListe",
            "filtre",
            "filtre"
          )
        ),
        "string"
      ),
      Murettebat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_255630_value",
            "value",
            "MurettebatComboListe",
            "filtre",
            "filtre"
          )
        ),
        "string"
      ),
      Yolcular_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "rezervasyonliste_758026_value",
            "value",
            "YolcuKomboListe",
            "filtre",
            "filtre"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "RezervasyonListe/RezervasyonListeComponent_135352_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonSearch = result?.data.rezervasyonSearch;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.RezervasyonListeComponent_135352_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  RezervasyonListeComponent_135352_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 =
      stateVars.RezervasyonSearch ?? this.state.RezervasyonSearch;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_209173_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "rezervasyonliste_399769_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(null, "Guid")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonListe",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_785184_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "rezervasyonliste_399769_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(null, "Guid")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonListe",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_321240_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "rezervasyonliste_399769_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonListe",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_176359_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "UcusId",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "RezervasyonNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "rezervasyonliste_399769_value",
          "rezervasyonNo"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "MasrafMode",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "RezervasyonListe",
      "UcusForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  RezervasyonListeComponent_690140_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.RezervasyonListePageInit();
    }
  }
}
